// extracted by css-extract-rspack-plugin
export default {"ratingChooser":"rating-chooser--kBoV0m7_pPsd2wfw","ratingChooserRadio":"rating-chooser-radio--OzUvFIztTecIQfxR","ratingChooserItem":"rating-chooser-item--A35YQ2sATh8DKyhW"};